import { __spreadArray, __read } from 'tslib';

/**
 * Merges two arrays of script objects, using `id` as the unique key.
 * Objects in `overrides` will overwrite those in `base` if they share the same `id`.
 *
 * @param base - The default array of scripts (e.g. baseThirdPartyScripts)
 * @param overrides - Consumer-supplied array that can override by `id`
 * @returns A new array of merged scripts
 */
function mergeScriptsById(base, overrides) {
    if (base === void 0) { base = []; }
    if (overrides === void 0) { overrides = []; }
    return Object.values(__spreadArray(__spreadArray([], __read(base), false), __read(overrides), false).reduce(function (acc, script) {
        acc[script.id] = script;
        return acc;
    }, {}));
}

export { mergeScriptsById };
//# sourceMappingURL=mergeScriptsById.esm.js.map
